<template>
  <div id="app">
    <div v-if="!appReady" class="app-splash">
      <header class="app-splash-header">
        <img src="@/assets/images/fashionphile.svg" alt height="30" />
      </header>
      <div class="app-splash-body">
        <img class="app-splash-knot" src="@/assets/images/knot.svg" alt="Loading" />
      </div>
    </div>
    <RouterView v-if="appReady" />
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      appReady: false
    }
  },
  mounted () {
    // Resolves after the first navigation fully settles — including the router
    // guard's wait on Clerk and the initial account fetch — so the splash
    // covers the whole boot, not just the Clerk script load.
    this.$router.onReady(() => {
      this.appReady = true
    })
  }
}
</script>

<style scoped>
.app-splash {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
}
.app-splash-header {
  height: 70px;
  background: #000;
  display: flex;
  align-items: center;
  padding: 0 24px;
}
.app-splash-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-splash-knot {
  height: 88px;
  animation: splash-pulse 1.4s ease-in-out infinite;
}
@keyframes splash-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.35; transform: scale(0.92); }
}
</style>
